import type { EditorAPI } from '#packages/editorAPI';
import { appMarketUtils } from '#packages/tpa';
import type {
  AppDefinitionId,
  EditorClientSpecMapEntry,
} from 'types/documentServices';

import { APP_MANAGER_APPS_LIST } from './constants';

export const getAppsList = (editorAPI: EditorAPI) => {
  const isBlocksApp = appMarketUtils.isBuilderType;
  const isUnifiedComponentApp = (app: EditorClientSpecMapEntry) =>
    app?.appFields?.newEditorSchemaVersion === 'externalUnifiedComponents';

  const installedBlocksApps = editorAPI.dsRead.platform
    .getInstalledEditorApps()
    .reduce((acc, app) => {
      if (
        !APP_MANAGER_APPS_LIST.includes(app.appDefinitionId) &&
        (isBlocksApp(app) || isUnifiedComponentApp(app))
      ) {
        acc.push(app.appDefinitionId);
      }
      return acc;
    }, []);
  const supportedApps = APP_MANAGER_APPS_LIST.concat(installedBlocksApps);
  return supportedApps;
};

export const isSupportedApp = (
  editorAPI: EditorAPI,
  appDefinitionId: AppDefinitionId,
) => getAppsList(editorAPI).includes(appDefinitionId);
